import { useState } from "react";
import { H4, UL } from "../../../../AbstractElements";
import { LayoutTypes } from "../../../../Constant";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { setOpenCus } from "../../../../Redux-Toolkit/Reducers/ThemeCustomizerSlice";
import ConfigDB from "../../../../config/ThemeConfig";
import BoxLayout from "./BoxLayout";
import LTR from "./LTR";
import RTL from "./RTL";

const LayoutType = () => {
  const dispatch = useAppDispatch();
  const localStorageLayout = ConfigDB.data.settings.layout_type;
  const [layout_type, setLayout_type] = useState(localStorageLayout);

  const handleLayout = (layout: string) => {
    setLayout_type(layout);
    dispatch(setOpenCus(false));
    if (layout === "rtl") {
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
      document.body.classList.remove("box-layout");
      document.documentElement.dir = "rtl";
      ConfigDB.data.settings.layout_type = "rtl"
    } else if (layout === "ltr") {
      document.body.classList.add("ltr");
      document.body.classList.remove("rtl");
      document.body.classList.remove("box-layout");
      document.documentElement.dir = "ltr";
      ConfigDB.data.settings.layout_type = "ltr"
    } else if (layout === "box-layout") {
      document.body.classList.remove("ltr");
      document.body.classList.remove("rtl");
      document.body.classList.add("box-layout");
      document.body.classList.remove("offcanvas");
      document.documentElement.dir = "ltr";
      ConfigDB.data.settings.layout_type = "box-layout";
    }
  };
  return (
    <div>
      <H4 className="mt-0 pt-0">{LayoutTypes}</H4>
      <UL className="main-layout layout-grid flex-row simple-list">
        <LTR handleLayout={handleLayout} layout_type={layout_type} />
        <RTL handleLayout={handleLayout} layout_type={layout_type} />
        <BoxLayout handleLayout={handleLayout} layout_type={layout_type} />
      </UL>
    </div>
  );
};

export default LayoutType;
